import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import {
  CC_ALERT_WARNING_BODY,
  CC_ALERT_WARNING_PANEL,
  CC_ALERT_WARNING_TITLE,
} from "@/components/case-checking/caseCheckingChrome";

export function ReviewInProgressDisclaimer({ className }: { className?: string }) {
  return (
    <div
      className={clsx(CC_ALERT_WARNING_PANEL, "flex items-start gap-2.5 px-3 py-2.5", className)}
      role="status"
      data-testid="review-in-progress-disclaimer"
    >
      <FontAwesomeIcon icon={faTriangleExclamation} className={clsx("mt-0.5 h-4 w-4 shrink-0", CC_ALERT_WARNING_TITLE)} />
      <div className="min-w-0 text-sm">
        <p className={CC_ALERT_WARNING_TITLE}>File check still running</p>
        <p className={clsx("mt-0.5", CC_ALERT_WARNING_BODY)}>
          Agent outputs on this case may still change. Your guided review can go stale even if you carry answers forward
          on a re-run — refresh your decisions after processing finishes.
        </p>
      </div>
    </div>
  );
}
